import React from 'react';

export  {default as InstagramIcon }from 'react-icons/lib/fa/instagram';
export {default as TwitterIcon }from 'react-icons/lib/fa/twitter';
export {default as  WebsiteIcon }from 'react-icons/lib/fa/globe';
export  {default as FacebookIcon }from 'react-icons/lib/fa/facebook-official';
export {default as YoutubeIcon} from 'react-icons/lib/fa/youtube-square';
export {default as SnapchatIcon} from 'react-icons/lib/fa/snapchat-ghost';
export {default as PinterestIcon} from 'react-icons/lib/fa/pinterest';

export  {default as SortUpIcon }from 'react-icons/lib/md/arrow-drop-up';
export  {default as SortDownIcon }from 'react-icons/lib/md/arrow-drop-down';
export  {default as ArrowLeft }from 'react-icons/lib/md/arrow-back';
export  {default as ArrowRight }from 'react-icons/lib/md/arrow-forward';
export  {default as EmptyBoxIcon} from 'react-icons/lib/md/inbox';
export  {default as BackButtonIcon }from 'react-icons/lib/md/keyboard-backspace';
export  {default as CheckIcon }from 'react-icons/lib/fa/check-circle-o';
export {default as TrashIcon} from 'react-icons/lib/fa/trash-o'
export {default as XIcon} from 'react-icons/lib/io/close'
export { default as PencilIcon} from 'react-icons/lib/fa/pencil'
export { default as InputIcon} from 'react-icons/lib/md/input'

export {default as ThreeDotsHorizontalIcon} from 'react-icons/lib/io/more';
export {default as EmptyIcon} from 'react-icons/lib/io/ios-refresh-empty'
export {default as CartIcon} from 'react-icons/lib/io/ios-cart-outline';
export {default as ExternalLinkIcon} from 'react-icons/lib/fa/external-link';
export {default as TickIcon } from 'react-icons/lib/fa/check'
export {default as NextIcon} from 'react-icons/lib/fa/chevron-right'
export {default as PreviousIcon} from 'react-icons/lib/fa/chevron-left'
export {default as PhoneIcon} from 'react-icons/lib/fa/phone'
export {default as EyeOpen} from 'react-icons/lib/fa/eye'
export {default as EyeClose} from 'react-icons/lib/fa/eye-slash'
export {default as PlusIcon} from 'react-icons/lib/fa/plus'
export {default as PdfDownloadIcon} from 'react-icons/lib/fa/file-pdf-o'
export const TikTokIcon = (props = {})=> <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path fill="currentColor" d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/>
</svg>

export {default as HelpIcon} from 'react-icons/lib/fa/question-circle-o';
export {default as HeartIconFill} from 'react-icons/lib/fa/heart'
export {default as HeartIconOutline} from 'react-icons/lib/fa/heart-o'
export {default as ExcelIcon} from 'react-icons/lib/fa/file-excel-o'
export {default as MdExpandMore} from 'react-icons/lib/md/expand-more';


//export const CartIcon =({ width, height }) => <img src={require('../assets/cart.svg')} width={width} height={height} />;
//export const CouponIcon =({ width, height }) => <img src={require('../assets/discount.svg')} width={width} height={height} />;
